import { generateCSS } from 'Common/components/Form';

const styleGenerator = () => ({
  base: generateCSS({
    display: 'none'
  })
});

export default styleGenerator;
